module.exports = __webpack_public_path__ + "images/a39f41b1de2ed968abad1a3c51fc47d3.png";